import { render } from "./Loading.vue?vue&type=template&id=514aec0c&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=514aec0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-514aec0c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "514aec0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('514aec0c', script)) {
    api.reload('514aec0c', script)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=514aec0c&scoped=true", () => {
    api.rerender('514aec0c', render)
  })

}

script.__file = "common/src/views/Loading.vue"

export default script